import { put } from "@redux-saga/core/effects";
import axios from "axios";

import { IUser, SignUpRequestActionType } from "../types";
import { AuthService, SignUpRequestResponse } from "../../../services/auth";
import { signUpSuccess, signUpFailure } from "../actionCreators";
import { IErrorType } from "../../types/errors.d";

export function* signUpSaga({
  payload: {
    country,
    first_name,
    last_name,
    phone,
    email,
    password,
    redirect_url,
  },
}: SignUpRequestActionType) {
  try {
    const {
      data: { data },
    }: SignUpRequestResponse = yield AuthService.signUp({
      country,
      first_name,
      last_name,
      phone,
      email,
      password,
      redirect_url,
    });

    yield put(signUpSuccess(data as IUser));
  } catch (error) {
    if (axios.isAxiosError(error))
      yield put(
        signUpFailure({
          errorType: IErrorType.AXIOS,
          data: error.response ? error.response.data : null,
        })
      );
    else
      yield put(signUpFailure({ errorType: IErrorType.NATIVE, data: error }));
  }
}
